import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { AngebotPosition, deleteAngebotPosition } from 'api/angebotPosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface AngebotPositionDeleteProps {
    angebotPosition: AngebotPosition;
    onClose: (refetch: boolean) => void;
}

export const AngebotPositionDelete: React.FC<AngebotPositionDeleteProps> = ({ angebotPosition, onClose }) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (angebotPosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteAngebotPosition(angebotPosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Angebotsposition löschen',
                subText: 'Angebotsposition "' + angebotPosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
